import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=b9120814&"
import script from "./Sold.vue?vue&type=script&lang=js&"
export * from "./Sold.vue?vue&type=script&lang=js&"
import style0 from "./Sold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports